//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapActions } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";

export default {
    name: "ExportEntityModal",
    components: {
        AQRadio,
        AQModal,
        AQCard
    },
    props: {
        entityDetails: { type: Object, default: () => {} }
    },
    data() {
        return {
            type: "STRUCTURE",
            method: "DOWNLOAD",
            showModal: true
        };
    },
    computed: {
        save() {
            return {
                label: this.$t("globalDataModel.export")
            };
        },
        setTitle() {
            return this.$t("globalDataModel.exportConfig");
        },
        showMethodContainer() {
            return this.type === "DATA";
        }
    },
    methods: {
        ...mapActions("GDM", ["exportExcel", "actExportExcelByEmail"]),
        actionsDlg($event) {
            if ($event === "primary") {
                if (this.method === "DOWNLOAD") {
                    this.$store.commit("GDM/setExportFinished", true);
                    this.downloadExcel();
                } else {
                    const payload = {
                        typeOfExport: this.type,
                        entityCode: this.entityDetails.code
                    };
                    this.actExportExcelByEmail(payload).then(() => {
                        this.$toast.showNotify({
                            message: this.$t("globalDataModel.exportByEmail"),
                            timeout: 5000,
                            type: "info"
                        });
                    });
                }
                this.$emit("input", false);
            } else if ($event === "close") {
                this.$emit("input", false);
            }
        },
        downloadExcel() {
            const payload = {
                type: this.type,
                code: this.entityDetails.code
            };
            this.exportExcel(payload).then(rsp => {
                const suffix = this.type === "STRUCTURE" ? "_s" : "_d";
                const blob = new Blob([rsp.data],
                    {
                        type: rsp.headers["content-type"]
                    });
                const downloadUrl = URL.createObjectURL(blob);
                const anchor = document.createElement("a");
                anchor.href = downloadUrl;
                anchor.download = `${this.entityDetails.name}${suffix}.xlsx`;
                document.body.appendChild(anchor);
                anchor.click();
                setTimeout(() => {
                    document.body.removeChild(anchor);
                    window.URL.revokeObjectURL(downloadUrl);
                }, 0);
                this.$emit("input", false);
                this.$toast.showNotify({
                    message: this.type === "STRUCTURE" ? this.$t("globalDataModel.successExportStructure") : this.$t("globalDataModel.successExportData"),
                    timeout: 5000,
                    type: "success"
                });
                this.$store.commit("GDM/setExportFinished", false);
            }).catch(error => {
                console.error(error);
            });
        }
    }
};
